/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../libs/graphql/src/lib/graphql/generated/types'
export type BackofficeUserActivationFieldsFragment = {
  __typename?: 'BackofficeUser'
  backofficeEnabled: boolean | null
  adminPanelEnabled: boolean | null
}

export const BackofficeUserActivationFieldsFragmentDoc = gql`
    fragment BackofficeUserActivationFields on BackofficeUser {
  backofficeEnabled
  adminPanelEnabled
}
    `
